// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_od-5";
export var filledCircle = "_od-4";
export var historyEntry = "_od-3";
export var messageSideLeft = "_od-1";
export var messageSideRight = "_od-2";
export var orderTrackingCarouselWrapper = "_od-6";
export var orderTrackingInfoContainer = "_od-0";